import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, FormSelect, FormLabel, Modal} from "react-bootstrap";
import { FaFilePdf } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { FaRegEdit, FaSearch, FaFilter, FaEraser, FaRegClock, FaCheck, FaExclamationCircle, FaExclamationTriangle } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Paginacao from '../../common/pagination';
import { formataDataExibicao, formataDataHoraExibicao, formatarValorLocal, getCurrentUser, statusExame, grupoEtario, estados, statusExamesSelecionados, isLaudoBloqueadoParaUsuarioAtual, isDataNaoInformada } from '../../common/utils';
import { getConfig } from '../../common/config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

class Exames extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            limit: 100,
            loading: true,
            campos_personalizados_header: [],
            filtro_campos_personalizados: {},
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_cidade: '',
            filtro_uf: '',
            filtro_status_programa_id: '',
            filtro_status_programa_nome: '',
            filtro_data_recebimento_inicio: '',
            filtro_data_recebimento_fim: '',
            filtro_data_agendamento_inicio: '',
            filtro_data_agendamento_fim: '',
            filtro_data_realizacao_inicio: '',
            filtro_data_realizacao_fim: '',
            filtro_nome_paciente: '',
            filtro_inicio: '',
            filtro_fim: '',
            filtro_status_pedido: '',
            filtro_exame: '',
            filtro_status_exame: '',
            showModalLaudo: false,
            laudoUrl: '',
            statusPedidoOptions: [],    // Status do Pedido de Exame
            statusExameOptions: [],     // Status do Exame
            tipo_data_filtro: 'recebimento', // Default date filter type
        };

    }

    handleAbrirLaudo = (url) => {
        this.setState({ showModalLaudo: true, laudoUrl: url });
    }

    handleFecharLaudo = () => {
        this.setState({ showModalLaudo: false, laudoUrl: '' });
    }

    getTipoArquivoQuestionario = (question) => {
        const tipoConfigurado = question?.upload_tipo || question?.tipo_arquivo || question?.arquivo_tipo || question?.upload?.tipo;
        return (typeof tipoConfigurado === 'string' && tipoConfigurado.trim()) ? tipoConfigurado.trim() : 'laudo';
    };

    extrairQuestionIdDoNomeArquivo = (nomeArquivo) => {
        const match = String(nomeArquivo || '').match(/\[qid:([^\]]+)\]/);
        return match ? match[1] : null;
    };

    isPerfilNegado = (perfisNegados = []) => {
        if (!Array.isArray(perfisNegados) || perfisNegados.length === 0) return false;

        const dados_usuario = getCurrentUser();
        const tipoUsuario = dados_usuario?.tipo_usuario || '';
        const perfisNormalizados = perfisNegados.map((p) => p === 'medico' ? 'medicos' : p);

        return perfisNormalizados.includes(tipoUsuario) ||
            (tipoUsuario === 'prestador' && perfisNormalizados.includes(dados_usuario?.prestador_categoria));
    };

    getRegrasVisualizacaoArquivosQuestionario = (configuracoesServico = {}) => {
        const questions = configuracoesServico?.questionario?.questions || [];
        const byQuestionId = {};
        const byTipo = {};

        questions.forEach((q) => {
            if (q.type !== 'file') return;

            const controlShow = q['control-show'] || q.control_show || {};
            const perfisNegados = q['deny-profiles'] || q.deny_profiles || controlShow['deny-profiles'] || controlShow.deny_profiles || [];

            if (!Array.isArray(perfisNegados) || perfisNegados.length === 0) return;

            byQuestionId[q.id] = perfisNegados;

            const tipoArquivo = this.getTipoArquivoQuestionario(q);
            byTipo[tipoArquivo] = [...new Set([...(byTipo[tipoArquivo] || []), ...perfisNegados])];
        });

        return { byQuestionId, byTipo };
    };

    podeVisualizarArquivoPorPerfil = (arquivo, configuracoesServico = {}) => {
        const regras = this.getRegrasVisualizacaoArquivosQuestionario(configuracoesServico);
        const questionId = this.extrairQuestionIdDoNomeArquivo(arquivo?.nome);

        if (questionId && this.isPerfilNegado(regras.byQuestionId[questionId] || [])) {
            return false;
        }

        const perfisNegadosPorTipo = regras.byTipo[arquivo?.tipo] || [];
        if (this.isPerfilNegado(perfisNegadosPorTipo)) {
            return false;
        }

        return true;
    };

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        let ambiente_programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : '';

        const search = (this.props?.location?.search ?? window.location.search) || '';
        const usp = new URLSearchParams(search);
        const qpStatusPedido = usp.get('status_pedido') || '';

        this.setState({
            filtro_programa_id: ambiente_programa_id,
            filtro_status_pedido: qpStatusPedido,
        }, () => {
            this.consultaRegistros();
            if (ambiente_programa_id) {
                this.carregaPrograma(ambiente_programa_id);
                this.carregaStatusMotivos(ambiente_programa_id);
            }
        })
    }

    consultaRegistros(){
        let dados_usuario = getCurrentUser();
        const programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : this.state.filtro_programa_id;
        
        let filtros = '?page=' + this.state.page_numb + '&limit=' + this.state.limit;
        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario
        })

        if(programa_id){
            filtros += `&programa_id=${programa_id}`
        }

        if(this.state.filtro_atendimento_id){
            filtros += `&atendimento_id=${this.state.filtro_atendimento_id}`
        }

        if(this.state.filtro_medico_id){
            filtros += `&medico_id=${this.state.filtro_medico_id}`
        }

        if(dados_usuario['prestador_categoria'] === 'medicos'){
            filtros += `&medico_id=${dados_usuario['prestador_id']}`
        }

        if(this.state.filtro_status_exame){
            filtros += `&status=${this.state.filtro_status_exame}`
        }

        if(this.state.filtro_status_pedido){
            filtros += `&status_pedido=${this.state.filtro_status_pedido}`
        }

        if(this.state.filtro_nome_paciente){
            filtros += `&beneficiario_nome=${encodeURIComponent(this.state.filtro_nome_paciente)}`
        }

        if(this.state.filtro_data_recebimento_inicio){
            filtros += `&recebimento_data_inicio=${this.state.filtro_data_recebimento_inicio}T00:00:00`
        }

        if(this.state.filtro_data_recebimento_fim){
            filtros += `&recebimento_data_fim=${this.state.filtro_data_recebimento_fim}T23:59:59`
        }

        if(this.state.filtro_data_agendamento_inicio){
            filtros += `&agendamento_data_inicio=${this.state.filtro_data_agendamento_inicio}`
        }

        if(this.state.filtro_data_agendamento_fim){
            filtros += `&agendamento_data_fim=${this.state.filtro_data_agendamento_fim}`
        }

        if(this.state.filtro_data_realizacao_inicio){
            filtros += `&realizacao_data_inicio=${this.state.filtro_data_realizacao_inicio}`
        }

        if(this.state.filtro_data_realizacao_fim){
            filtros += `&recebimento_data_fim=${this.state.filtro_data_realizacao_fim}`
        }

        if(this.state.filtro_status_programa_id){
            filtros += `&status_programa_id=${this.state.filtro_status_programa_id}`
        }
        
        if(this.state.filtro_diagnostico_id){
            filtros += `&diagnostico_id=${this.state.filtro_diagnostico_id}`
        }

        if(this.state.filtro_atendente){
            filtros += `&atendente_nome=${this.state.filtro_atendente}`
        }

        if(this.state.filtro_cidade){
            filtros += `&beneficiario_cidade=${this.state.filtro_cidade}`
        }

        if(this.state.filtro_uf){
            filtros += `&beneficiario_uf=${this.state.filtro_uf}`
        }

        Object.entries(this.state.filtro_campos_personalizados || {}).forEach(([campo, valor]) => {
            if (valor) {
                filtros += `&campos_personalizados[${encodeURIComponent(campo)}]=${encodeURIComponent(valor)}`;
            }
        });

        api.get(`/exames/solicitados/${filtros}`)
        .then(response => {
            // Get programa dados from first item if available
            const programaDados = response.data.results?.[0]?.dados_atendimento?.dados_programa || null;
            
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data,
                // Only overwrite if we don't have it or if we didn't fetch it explicitly (checking configuracoes might be a proxy, or just rely on carregaPrograma)
                // Actually, let's keep the existing logic but knowing that carregaPrograma will overwrite likely with more data if called
                // If we already have programa_dados with configuracoes, maybe we shouldn't overwrite with this one if it lacks it.
                // For safety, let's only set if we don't have it set from carregaPrograma yet
                programa_dados: this.state.programa_dados?.configuracoes ? this.state.programa_dados : (programaDados || this.state.programa_dados)
            });
            //console.log(response.data)
            
            response.data.results.forEach(item => {
                if(item.dados_campos_personalizados && Array.isArray(item.dados_campos_personalizados)) {
                    item.dados_campos_personalizados.forEach(campo => {
                        if(!this.state.campos_personalizados_header.some(c => c.id === campo.id)){
                            this.setState({
                                campos_personalizados_header: [...this.state.campos_personalizados_header, {nome: campo.nome, id: campo.id}]
                            })
                        }
                    })
                }
            })
                
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar exames, tente novamente.';

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'medico_id') {
            this.setState({
                filtro_medico_id: event?.value || '', 
                filtro_medico_nome: event?.label || '',  
            }, () => {
                //this.carregaPrestadores("", true)
            });
        }
        else if(fieldName == 'atendimento_id') {
            this.setState({ 
                filtro_atendimento_id: event?.value || '', 
                filtro_atendimento_nome: event?.label || '', 
            });
        } else if(fieldName == 'status_programa') {
            this.setState({ 
                filtro_status_programa_id: event?.value || '', 
                filtro_status_programa_nome: event?.label || '', 
            });
        } else if(fieldName == 'diagnostico') {
            this.setState({ 
                filtro_diagnostico_id: event?.value || '', 
                filtro_diagnostico_nome: event?.label || '', 
            });
        } else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event?.value || '', 
                filtro_programa_nome: event?.label || '', 
                filtro_status_programa_id: '',
                filtro_status_programa_nome: '',
                filtro_diagnostico_id: '',
                filtro_diagnostico_nome: '',
                filtro_medico_id: '',
                filtro_medico_nome: '',
                filtro_status_exame: '',
                filtro_status_pedido: '',
                filtro_campos_personalizados: {},
                campos_personalizados_header: [],
                focusStatusPrograma: false,
                focusDiagnostico: false,
                focusMedico: false,
            }), () => {
                this.carregaStatusMotivos(event?.value);
                this.carregaPrograma(event?.value);
            });
        } else if (fieldName === 'filtro_status_exame') { // Status Pedido
             this.setState({ filtro_status_exame: event?.value || '' });
        } else if (fieldName === 'filtro_uf') { // UF
            this.setState({ filtro_uf: event?.value || '' });
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangeTipoData = (e) => {
        // Support both react-select {value: ...} and standard event {target: {value: ...}}
        const val = e?.value ?? e?.target?.value;
        this.setState({ tipo_data_filtro: val });
        // Optional: clear other date filters when switching types if desired, 
        // but keeping them might be better for user experience if they switch back.
    };

    carregaProgramas = async (inputValue) => {
        //if(this.state.loading){
            try {
                let response;   
                response = await api.get(`/programas/?nome=${inputValue}`);
                const opcoes = response.data.results.map(programa => {
                    if (programa.id === parseInt(this.state.ambiente_programa_id)) {
                        this.setState({
                            filtro_programa_id: programa.id,
                            filtro_programa_nome: programa.nome
                        });
                    }
                    return {
                        value: programa.id,
                        label: programa.nome
                    };
                });
                
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar programas:', error);
                return [];
            }
        //}
    };

    carregaPrograma = async (id) => {
        if (!id) return;
        try {
            const response = await api.get(`/programas/${id}/`);
            if (response.data) {
                this.setState({
                    programa_dados: response.data
                });
            }
        } catch (error) {
            console.error('Erro ao carregar dados do programa:', error);
        }
    };


    renderRows = () => {   
        const dados_usuario = getCurrentUser();
        const filtro = (this.state.filtro_nome_paciente || '').toLowerCase();
        const ocultarColunasEspecificas = getConfig(this.state.programa_dados?.configuracoes, 'exames.ocultar_colunas_ID-CRM/UF-Transporte', false);

        if (!('results' in this.state.listRegistros) || this.state.listRegistros.results.length === 0) {
            let colSpan = dados_usuario.prestador_categoria !== 'medicos' ? 21 : 9;
            if (ocultarColunasEspecificas && dados_usuario.prestador_categoria !== 'medicos') {
                colSpan -= 4; // ID, CRM/UF, Motorista, Laudo
            }
            return (
                <tr>
                    <td colSpan={colSpan}>Nenhum exame solicitado encontrado</td>
                </tr>
            );
        }

        const resultadosFiltrados = this.state.listRegistros.results;

        if (dados_usuario.prestador_categoria !== 'medicos') {
            return resultadosFiltrados.map((item) =>
            <tr key={item.id}>
                {!ocultarColunasEspecificas && <td>{item.id}</td>}
                <td><a target="_blank" href={"/atendimentos/edit/"+(item.dados_atendimento?.uuid || item.dados_atendimento?.id)}>{item.dados_atendimento?.id || '-'}</a></td>
                <td>{item.dados_atendimento?.doenca || '-'}</td>
                {this.state.campos_personalizados_header.map(campoHeader => (
                    <td key={campoHeader.id}>{item.dados_campos_personalizados?.find(campo => campo.id === campoHeader.id)?.valor || '-'}</td>
                ))}
                <td>{item.dados_atendimento?.status_programa || '-'}</td>
                <td>{item.dados_atendimento?.paciente || '-'}</td>
                <td>{item.dados_atendimento?.cidade || '-'}</td>
                <td>{item.dados_atendimento?.uf || '-'}</td>
                <td>{item.dados_medico?.nome || '-'}</td>
                {!ocultarColunasEspecificas && <td>{item.dados_medico?.registro ? item.dados_medico.registro + '/' + item.dados_medico.registro_uf : '-'}</td>}
                <td>{item.dados_exame?.status ? this.getStatusPedidoLabel(item.dados_exame.status) : '-'}</td>
                <td>{!isDataNaoInformada(item.dados_exame?.data_recebimento) ? formataDataExibicao(item.dados_exame.data_recebimento) : '-'}</td>
                <td>{item.status ? this.getStatusExameLabel(item.status) : '-'}</td>
                <td>{!isDataNaoInformada(item.data_agendamento) ? formataDataExibicao(item.data_agendamento) : '-'}</td>
                <td>{!isDataNaoInformada(item.data_realizacao) ? formataDataExibicao(item.data_realizacao) : '-'}</td>
                <td>
                    {item.laboratorio_id ? (
                        <>
                            {item.dados_laboratorio?.nome}
                        </>
                    ) : (
                        <>
                            {item.dados_provedor_nao_credenciado?.nome_fantasia || '-'}
                        </>
                    )}
                </td>
                {!ocultarColunasEspecificas && <td>{item.dados_motorista?.nome || '-'}</td>}
                {!ocultarColunasEspecificas && (
                <td>
                    {['realizado', 'finalizado'].includes(item.status) && (() => {
                        const dadosAgendamento = item.dados_agendamento || {};
                        const arquivos = dadosAgendamento.arquivos || [];
                        const hasArquivos = arquivos.length > 0;

                        const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(this.state.programa_dados?.configuracoes);
                        const configuracoesServico = item.dados_servico_procedimento?.configuracoes || {};

                        let links = [];

                        if (hasArquivos) {
                            links = arquivos.filter(arq => arq.aprovado !== false).map(arq => ({
                                nome: arq.nome || 'Ver Laudo',
                                url: arq.arquivo,
                                tipo: arq.tipo,
                                bloqueadoPorPerfil: !this.podeVisualizarArquivoPorPerfil(arq, configuracoesServico)
                            }));
                        } else if (dadosAgendamento.arquivo_confirmacao) {
                            links = [{
                                nome: 'Ver Laudo',
                                url: dadosAgendamento.arquivo_confirmacao,
                                tipo: 'laudo',
                                bloqueadoPorPerfil: false
                            }];
                        }

                        if (links.length === 0) return '-';

                        return links.map((link, idx) => (
                            <div key={idx} className={idx > 0 ? "mt-1" : ""}>
                                {(!(isBloqueadoVisualizarLaudo && (link.tipo === 'laudo' || !link.tipo)) && !link.bloqueadoPorPerfil) ? (
                                    <>
                                        <Button 
                                            variant="outline-primary" 
                                            size="sm"
                                            onClick={() => this.handleAbrirLaudo(link.url)}
                                            title={link.nome}
                                            className="d-none d-md-inline-flex"
                                        >
                                            <FaFilePdf /> {links.length > 1 ? (link.nome.length > 15 ? link.nome.substring(0, 12) + '...' : link.nome) : 'Ver Laudo'}
                                        </Button>
                                        <Button
                                            as="a"
                                            variant="outline-primary"
                                            size="sm"
                                            href={link.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title={link.nome}
                                            className="d-inline-flex d-md-none"
                                        >
                                            <FaFilePdf className="me-1" /> Ver Laudo
                                        </Button>
                                    </>
                                ) : (
                                    <span className="text-muted small">
                                        <FaExclamationTriangle className="text-warning"/> Bloqueado
                                    </span>
                                )}
                            </div>
                        ));
                    })()}
                    {!['realizado', 'finalizado'].includes(item.status) && '-'}
                </td>
                )}
            </tr>
            );
        }        

        if (dados_usuario.prestador_categoria === 'medicos') {
           
            return resultadosFiltrados.map((item) =>
                <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                    <a target="_blank" href={"/atendimentos/edit/"+(item.dados_atendimento?.uuid || item.dados_atendimento?.id)}>
                    {item.dados_atendimento?.id || '-'}
                    </a>
                </td>
                <td>{item.dados_atendimento?.paciente || '-'}</td>
                <td>{item.dados_servico_procedimento?.nome || '-'}</td>
                <td>{item.dados_exame?.data_recebimento ? formataDataExibicao(item.dados_exame.data_recebimento) : '-'}</td>
                <td>
                    {item.dados_exame?.status ? this.getStatusPedidoLabel(item.dados_exame.status) : '-'}
                    {item.dados_exame?.status === 'recusado' && item.dados_exame?.motivo_recusa && (
                    <> ({item.dados_exame?.motivo_recusa})</>
                    )}
                </td>
                <td>{item.status ? this.getStatusExameLabel(item.status) : '-'}</td>
                <td>
                    {['realizado', 'finalizado'].includes(item.status) && (() => {
                        const dadosAgendamento = item.dados_agendamento || {};
                        const arquivos = dadosAgendamento.arquivos || [];
                        const hasArquivos = arquivos.length > 0;

                        const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(this.state.programa_dados?.configuracoes);
                        const configuracoesServico = item.dados_servico_procedimento?.configuracoes || {};

                        // Lista de arquivos a exibir (não recusados)
                        let links = [];

                        if (hasArquivos) {
                            links = arquivos.filter(arq => arq.aprovado !== false).map(arq => ({
                                nome: arq.nome || 'Ver Laudo',
                                url: arq.arquivo,
                                tipo: arq.tipo,
                                bloqueadoPorPerfil: !this.podeVisualizarArquivoPorPerfil(arq, configuracoesServico)
                            }));
                        } else if (dadosAgendamento.arquivo_confirmacao) {
                            // Se não tem array, usa o arquivo_confirmacao (legado)
                            links = [{
                                nome: 'Ver Laudo',
                                url: dadosAgendamento.arquivo_confirmacao,
                                tipo: 'laudo',
                                bloqueadoPorPerfil: false
                            }];
                        }

                        if (links.length === 0) return '-';

                        return links.map((link, idx) => (
                            <div key={idx} className={idx > 0 ? "mt-1" : ""}>
                                {(!(isBloqueadoVisualizarLaudo && (link.tipo === 'laudo' || !link.tipo)) && !link.bloqueadoPorPerfil) ? (
                                    <>
                                        <Button 
                                            variant="outline-primary" 
                                            size="sm"
                                            onClick={() => this.handleAbrirLaudo(link.url)}
                                            title={link.nome}
                                            className="d-none d-md-inline-flex"
                                        >
                                            <FaFilePdf /> {links.length > 1 ? (link.nome.length > 15 ? link.nome.substring(0, 12) + '...' : link.nome) : 'Ver Laudo'}
                                        </Button>
                                        <Button
                                            as="a"
                                            variant="outline-primary"
                                            size="sm"
                                            href={link.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title={link.nome}
                                            className="d-inline-flex d-md-none"
                                        >
                                            <FaFilePdf className="me-1" /> Ver Laudo
                                        </Button>
                                    </>
                                ) : (
                                    <span className="text-muted small">
                                        <FaExclamationTriangle className="text-warning"/> Bloqueado
                                    </span>
                                )}
                            </div>
                        ));
                    })()}
                    {!['realizado', 'finalizado'].includes(item.status) && '-'}
                </td>
                </tr>
            );
        }
        
    };

    carregarMedicos = async (busca) => {
        if (!this.state.focusMedico) {
            return [];
        }
        try {
            const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.filtro_programa_id}&categoria=medicos&nome=${busca}`);
            //const response = await api.get(`/programas/aplicacoes-status/`);
            const opcoesFiltradas = response.data.results.map(medico => ({
                value: medico.id,
                label: medico.nome,
                crm: medico.registro + ' - ' + medico.registro_uf,
            }));

            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar médicos:', error);
            Sentry.captureException('Erro ao carregar médicos:', error);
        }
    };

    carregarStatusPrograma = async (busca) => {
        if (!this.state.focusStatusPrograma) {
            return [];
        }
        try {
            const response = await api.get(`/programas/status/?nome=${busca}&programa_id=${this.state.filtro_programa_id}`);
            //const response = await api.get(`/programas/aplicacoes-status/`);
            const opcoesFiltradas = response.data.results.map(status => ({
                value: status.id,
                label: status.nome,
            }));

            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar status do programa:', error);
            Sentry.captureException('Erro ao carregar status do programa:', error);
        }
    };

    carregarDiagnostico = async (busca) => {
        if (!this.state.focusDiagnostico) {
            return [];
        }
        try {
            const response = await api.get(`/programas/doencas/?nome=${busca}&programa_id=${this.state.filtro_programa_id}`);
            const opcoesFiltradas = response.data.results.map(diagnostico => ({
                value: diagnostico.doenca_id,
                label: diagnostico.dados_doenca.nome,
            }));

            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar diagnóstico:', error);
            Sentry.captureException('Erro ao carregar diagnóstico:', error);
        }
    };


    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.consultaRegistros();
        });
        
    };

    filtrarExames = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.consultaRegistros()
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_programa_id: null,
            filtro_programa_nome: '',
            filtro_prestador_id: null,
            filtro_prestador_nome: '',
            filtro_status_exame: '',
            filtro_status_programa_id: '',
            filtro_status_programa_nome: '',
            filtro_cidade: '',
            filtro_uf: '',
            filtro_data_recebimento: '',
            filtro_data_recebimento_inicio: '',
            filtro_data_recebimento_fim: '',
            filtro_data_agendamento_inicio: '',
            filtro_data_agendamento_fim: '',
            filtro_data_realizacao_inicio: '',
            filtro_data_realizacao_fim: '',
            filtro_campos_personalizados: {},
            filtro_nome_paciente: '',
            filtro_diagnostico_id: '',
            filtro_diagnostico_nome: '',
            filtro_medico_id: '',
            filtro_medico_nome: '',
            filtro_atendimento_id: '',
            filtro_atendente: '',
            tipo_data_filtro: 'recebimento',
            page_numb: 1, // Reseta a paginação, se necessário
        }, () => {
            this.consultaRegistros(); // Chama a função para consultar registros com os filtros limpos
        });
    };

    exportarCSV = async () => {
        // Mostra o loading
        Swal.fire({
            title: 'Exportando dados...',
            text: 'Aguarde enquanto o arquivo é gerado',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            let dados_usuario = getCurrentUser();
            const programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : this.state.filtro_programa_id;
            
            // Monta os filtros
            let filtros = '?';

            if(programa_id){
                filtros += `&programa_id=${programa_id}`
            }

            if(this.state.filtro_atendimento_id){
                filtros += `&atendimento_id=${this.state.filtro_atendimento_id}`
            }

            if(this.state.filtro_medico_id){
                filtros += `&medico_id=${this.state.filtro_medico_id}`
            }
   
            if(dados_usuario['prestador_categoria'] === 'medicos'){
                filtros += `&medico_id=${dados_usuario['prestador_id']}`
            }

            if(this.state.filtro_status_exame){
                filtros += `&status_exame=${this.state.filtro_status_exame}`
            }
            
            if(this.state.filtro_status_pedido){
                filtros += `&status_pedido=${this.state.filtro_status_pedido}`
            }

            if(this.state.filtro_data_recebimento_inicio){
                filtros += `&recebimento_data_inicio=${this.state.filtro_data_recebimento_inicio} 00:00:00`
            }

            if(this.state.filtro_data_recebimento_fim){
                filtros += `&recebimento_data_fim=${this.state.filtro_data_recebimento_fim} 23:59:59`
            }

            if(this.state.filtro_inicio && !this.state.filtro_data_recebimento_inicio){
                filtros += `&recebimento_data_inicio=${this.state.filtro_inicio}`
            }
            if(this.state.filtro_fim && !this.state.filtro_data_recebimento_fim){
                filtros += `&recebimento_data_fim=${this.state.filtro_fim}`
            }
            if(this.state.filtro_exame){
                filtros += `&exame_nome=${encodeURIComponent(this.state.filtro_exame)}`
            }

            if(this.state.filtro_data_agendamento_inicio){
                filtros += `&agendamento_data_inicio=${this.state.filtro_data_agendamento_inicio}`
            }

            if(this.state.filtro_data_agendamento_fim){
                filtros += `&agendamento_data_fim=${this.state.filtro_data_agendamento_fim}`
            }

            if(this.state.filtro_data_realizacao_inicio){
                filtros += `&realizacao_data_inicio=${this.state.filtro_data_realizacao_inicio}`
            }

            if(this.state.filtro_data_realizacao_fim){
                filtros += `&realizacao_data_fim=${this.state.filtro_data_realizacao_fim}`
            }

            if(this.state.filtro_status_programa_id){
                filtros += `&status_programa_id=${this.state.filtro_status_programa_id}`
            }
            
            if(this.state.filtro_diagnostico_id){
                filtros += `&diagnostico_id=${this.state.filtro_diagnostico_id}`
            }

            if(this.state.filtro_atendente){
                filtros += `&atendente_nome=${this.state.filtro_atendente}`
            }

            if(this.state.filtro_cidade){
                filtros += `&beneficiario_cidade=${this.state.filtro_cidade}`
            }

            if(this.state.filtro_uf){
                filtros += `&beneficiario_uf=${this.state.filtro_uf}`
            }
            
            if(this.state.filtro_nome_paciente){
                 filtros += `&beneficiario_nome=${encodeURIComponent(this.state.filtro_nome_paciente)}`
            }

            Object.entries(this.state.filtro_campos_personalizados || {}).forEach(([campo, valor]) => {
                if (valor) {
                    filtros += `&campos_personalizados[${encodeURIComponent(campo)}]=${encodeURIComponent(valor)}`;
                }
            });

            // Define as colunas dinamicamente baseado na visualização atual
            const ocultarColunasEspecificas = getConfig(this.state.programa_dados?.configuracoes, 'exames.ocultar_colunas_ID-CRM/UF-Transporte', false);
            let columns = [];

            if (dados_usuario['prestador_categoria'] !== 'medicos') {
                if (!ocultarColunasEspecificas) columns.push({ label: 'ID', slug: 'id' });
                columns.push({ label: 'ID Atendimento', slug: 'atendimento_id' });
                columns.push({ label: 'Diagnóstico', slug: 'diagnostico' });

                // Campos Personalizados
                this.state.campos_personalizados_header.forEach(campo => {
                     // Nota: Backend precisa saber lidar com id numerico ou slug. 
                     // Como a implementação atual do backend ignora campos personalizados por complexidade,
                     // eles aparecerão no header mas virão vazios por enquanto, mantendo a consistência visual.
                    columns.push({ label: campo.nome, slug: `custom_${campo.id}` });
                });

                columns.push({ label: 'Status do Programa', slug: 'status_programa' });
                columns.push({ label: 'Paciente', slug: 'paciente' });
                columns.push({ label: 'Cidade', slug: 'cidade' });
                columns.push({ label: 'UF', slug: 'uf' });
                columns.push({ label: 'Médico Solicitante', slug: 'medico' });
                if (!ocultarColunasEspecificas) columns.push({ label: 'CRM/UF', slug: 'crm' });
                columns.push({ label: 'Status do Pedido', slug: 'status_pedido' });
                columns.push({ label: 'Data de Recebimento', slug: 'data_recebimento' });
                columns.push({ label: 'Status do Exame', slug: 'status_exame' });
                columns.push({ label: 'Data de Agendamento', slug: 'data_agendamento' });
                columns.push({ label: 'Data de Realização', slug: 'data_realizacao' });
                columns.push({ label: 'Local de Realização', slug: 'local_realizacao' });
                if (!ocultarColunasEspecificas) columns.push({ label: 'Motorista', slug: 'motorista' });
                if (!ocultarColunasEspecificas) columns.push({ label: 'Laudo', slug: 'laudo' });

            } else {
                // Visão de Médicos
                columns.push({ label: 'ID', slug: 'id' });
                columns.push({ label: 'Atendimento', slug: 'atendimento_id' });
                columns.push({ label: 'Paciente', slug: 'paciente' });
                columns.push({ label: 'Exame', slug: 'exame' });
                columns.push({ label: 'Data de Solicitação', slug: 'data_solicitacao' });
                columns.push({ label: 'Status do Pedido', slug: 'status_pedido' });
                columns.push({ label: 'Status do Exame', slug: 'status_exame' });
                columns.push({ label: 'Laudo', slug: 'laudo' });
            }

            // Adiciona definição de colunas na URL
            filtros += `&columns=${encodeURIComponent(JSON.stringify(columns))}`;

            // Faz a requisição para exportação
            const response = await api.get(`/exames/solicitados/exportar/${filtros}`, {
                responseType: 'blob', // Importante para download de arquivo
            });
            
            // Extrai nome do arquivo do header se disponível
            let filename = `exames_export_${new Date().toISOString().split('T')[0]}.csv`;
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) { 
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            // Download do arquivo
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            // Sucesso
            Swal.close();

        } catch (error) {
            console.error('Erro ao exportar:', error);
            Swal.fire({
                icon: 'error',
                title: 'Erro na exportação',
                text: 'Ocorreu um erro ao exportar os dados. Tente novamente.'
            });
        }
    };

    carregaStatusMotivos = async (programaId) => {
        const programa = programaId || this.state.filtro_programa_id;
        if (!programa) {
            this.setState({ statusPedidoOptions: [], statusExameOptions: [] });
            return;
        }

        try {
            const [resPedido, resExame] = await Promise.all([
                api.get(`/exames/status_motivos/?programa_id=${encodeURIComponent(programa)}&area=pedido-exame&tipo=status`),
                api.get(`/exames/status_motivos/?programa_id=${encodeURIComponent(programa)}&area=exame&tipo=status`)
            ]);

            const mapList = (resp) => {
                const list = resp?.data?.results || resp?.data || [];
                return Array.isArray(list) ? list.map(item => ({
                    value: item.slug ?? String(item.id ?? item),
                    label: item.nome ?? String(item.slug ?? item.id ?? item)
                })) : [];
            };

            this.setState({
                statusPedidoOptions: mapList(resPedido),
                statusExameOptions: mapList(resExame)
            });
        } catch (err) {
            console.error('Erro carregando status:', err);
            this.setState({ statusPedidoOptions: [], statusExameOptions: [] });
        }
    };

    getStatusPedidoLabel = (slug) => {
        const status = this.state.statusPedidoOptions.find(s => s.value === slug);
        if (status) return status.label;
        // Fallback para o objeto fixo
        return statusExame[slug] || slug || '-';
    };

    getStatusExameLabel = (slug) => {
        const status = this.state.statusExameOptions.find(s => s.value === slug);
        if (status) return status.label;
        // Fallback para o objeto fixo
        return statusExamesSelecionados[slug] || slug || '-';
    };

    getUltimosPorAtendimento = (rows) => {
        // Decide o “mais novo”: prioriza data_criacao; se não tiver, usa dados_exame.data_recebimento; desempate por id
        const getKey = (r) => r?.dados_atendimento?.id;
        const getScore = (r) => {
            const a = Date.parse(r?.data_criacao ?? '') || 0;
            const b = Date.parse(r?.dados_exame?.data_recebimento ?? '') || 0;
            const base = a || b;
            return [base, (r?.id ?? 0)];
        };

        const map = new Map();
        for (const r of (rows || [])) {
            const atdId = getKey(r);
            if (!atdId) continue;
            const curr = map.get(atdId);
            if (!curr) { map.set(atdId, r); continue; }

            const [ns, nid] = getScore(r);
            const [cs, cid] = getScore(curr);
            if (ns > cs || (ns === cs && nid > cid)) {
            map.set(atdId, r);
            }
        }
        return Array.from(map.values());
    };


    render() {        
        if (!hasPerm('view_exames')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_usuario = getCurrentUser();
        const ocultarColunasEspecificas = getConfig(this.state.programa_dados?.configuracoes, 'exames.ocultar_colunas_ID-CRM/UF-Transporte', false);

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Exames</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.filtrarExames}>
                            {dados_usuario['prestador_categoria'] !== 'medicos' && (
                            <>
                                <Row>
                                    {dados_usuario['ambiente_programa_id'] === "" && (
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Programa</Form.Label>
                                            <AsyncSelect          
                                                key={this.state.programa_select_key}                                  
                                                cacheOptions
                                                loadOptions={this.carregaProgramas}
                                                defaultOptions
                                                name="programa_id"
                                                placeholder={'Buscar programa...'}
                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    )}
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Status do Programa</Form.Label>
                                            <AsyncSelect
                                                key={`${this.state.focusStatusPrograma}-${this.state.filtro_programa_id}`}
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.statusProgramaSearchTimeout);
                                                        this.statusProgramaSearchTimeout = setTimeout(() => {
                                                            resolve(this.carregarStatusPrograma(inputValue));
                                                        }, 700);
                                                    });
                                                }}
                                                onFocus={() => {
                                                    this.setState({
                                                        focusStatusPrograma: true
                                                    });
                                                }}
                                                autoFocus={this.state.focusStatusPrograma}
                                                openMenuOnFocus={this.state.focusStatusPrograma}
                                                defaultOptions
                                                onChange={e => this.handleChangeFiltros(e, 'status_programa')}
                                                placeholder="Buscar status do programa..."
                                                noOptionsMessage={() => "Nenhum status do programa encontrado"}
                                                value={this.state.filtro_status_programa_id ? { value: this.state.filtro_status_programa_id, label: this.state.filtro_status_programa_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Status do Pedido do Exame</Form.Label>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isClearable
                                                name="filtro_status_exame"
                                                placeholder="Todos os Status"
                                                value={
                                                    (this.state.statusPedidoOptions.length > 0 ? this.state.statusPedidoOptions : Object.entries(statusExame).map(([key, value]) => ({ value: key, label: value })))
                                                    .find(option => option.value === this.state.filtro_status_exame) || null
                                                }
                                                onChange={e => this.handleChangeFiltros(e, 'filtro_status_exame')}
                                                options={this.state.statusPedidoOptions.length > 0 ? this.state.statusPedidoOptions : Object.entries(statusExame).map(([key, value]) => ({ value: key, label: value }))}
                                                noOptionsMessage={() => "Nenhum status encontrado"}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Diagnóstico/Hipótese Diagnóstica</Form.Label>
                                            <AsyncSelect
                                                key={`${this.state.focusDiagnostico}-${this.state.filtro_programa_id}`}
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.diagnosticoSearchTimeout);
                                                        this.diagnosticoSearchTimeout = setTimeout(() => {
                                                            resolve(this.carregarDiagnostico(inputValue));
                                                        }, 700);
                                                    });
                                                }}
                                                onFocus={() => {
                                                    this.setState({
                                                        focusDiagnostico: true
                                                    });
                                                }}
                                                autoFocus={this.state.focusDiagnostico}
                                                openMenuOnFocus={this.state.focusDiagnostico}
                                                defaultOptions
                                                onChange={e => this.handleChangeFiltros(e, 'diagnostico')}
                                                placeholder="Buscar diagnóstico..."
                                                noOptionsMessage={() => "Nenhum diagnóstico encontrado"}
                                                value={this.state.filtro_diagnostico_id ? { value: this.state.filtro_diagnostico_id, label: this.state.filtro_diagnostico_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Médico Solicitante</Form.Label>
                                            <AsyncSelect
                                                key={`${this.state.focusMedico}-${this.state.filtro_programa_id}`}
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.medicoSearchTimeout);
                                                        this.medicoSearchTimeout = setTimeout(() => {
                                                            resolve(this.carregarMedicos(inputValue));
                                                        }, 700);
                                                    });
                                                }}
                                                onFocus={() => {
                                                    this.setState({
                                                        focusMedico: true
                                                    });
                                                }}
                                                autoFocus={this.state.focusMedico}
                                                openMenuOnFocus={this.state.focusMedico}
                                                defaultOptions
                                                onChange={e => this.handleChangeFiltros(e, 'medico_id')}
                                                placeholder="Buscar médico..."
                                                noOptionsMessage={() => "Nenhum médico encontrado"}
                                                value={this.state.filtro_medico_id ? { value: this.state.filtro_medico_id, label: this.state.filtro_medico_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo de Data</Form.Label>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                value={[
                                                    { value: 'recebimento', label: 'Data de solicitação' },
                                                    { value: 'agendamento', label: 'Data de agendamento' },
                                                    { value: 'realizacao', label: 'Data de realização' }
                                                ].find(option => option.value === this.state.tipo_data_filtro)}
                                                onChange={this.handleChangeTipoData}
                                                options={[
                                                    { value: 'recebimento', label: 'Data de solicitação' },
                                                    { value: 'agendamento', label: 'Data de agendamento' },
                                                    { value: 'realizacao', label: 'Data de realização' }
                                                ]}
                                                placeholder="Selecione o tipo de data"
                                            />
                                        </Form.Group>
                                    </Col>
                                    
                                    {(() => {
                                        let startField, endField;
                                        if (this.state.tipo_data_filtro === 'agendamento') {
                                            startField = 'filtro_data_agendamento_inicio';
                                            endField = 'filtro_data_agendamento_fim';
                                        } else if (this.state.tipo_data_filtro === 'realizacao') {
                                            startField = 'filtro_data_realizacao_inicio';
                                            endField = 'filtro_data_realizacao_fim';
                                        } else {
                                            startField = 'filtro_data_recebimento_inicio';
                                            endField = 'filtro_data_recebimento_fim';
                                        }

                                        return (
                                            <>
                                                <Col sm={3} xs={12}> 
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>De</Form.Label>
                                                        <Form.Control 
                                                            type="date" 
                                                            name={startField} 
                                                            value={this.state[startField]} 
                                                            onChange={e => this.handleChangeFiltros(e, startField)} 
                                                        />    
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={3} xs={12}> 
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Até</Form.Label>
                                                        <Form.Control 
                                                            type="date" 
                                                            name={endField} 
                                                            value={this.state[endField]} 
                                                            onChange={e => this.handleChangeFiltros(e, endField)} 
                                                        />    
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        );
                                    })()}

                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>UF</Form.Label>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isClearable
                                                name="filtro_uf" 
                                                value={
                                                    Object.entries(estados).map(([key, value]) => ({ value: key, label: value }))
                                                    .find(option => option.value === this.state.filtro_uf) || null
                                                }
                                                onChange={e => this.handleChangeFiltros(e, 'filtro_uf')}
                                                options={Object.entries(estados).map(([key, value]) => ({ value: key, label: value }))}
                                                placeholder="Todos os UFs"
                                                noOptionsMessage={() => "Nenhum UF encontrado"}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Navegadora</Form.Label>
                                            <Form.Control type="text" name="filtro_atendente" value={this.state.filtro_atendente} onChange={e => this.handleChangeFiltros(e, 'filtro_atendente')} />    
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>ID do Atendimento</Form.Label>
                                            <Form.Control type="number" name="filtro_atendimento_id" value={this.state.filtro_atendimento_id} onChange={e => this.handleChangeFiltros(e, 'filtro_atendimento_id')} />    
                                        </Form.Group>
                                    </Col>
                                    
                                    {this.state.campos_personalizados_header.map(campo => (
                                        <Col sm={3} xs={12} key={`filtro-${campo.id}`}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{campo.nome}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={this.state.filtro_campos_personalizados[campo.id] || ''}
                                                    onChange={(e) => {
                                                        const updated = { ...this.state.filtro_campos_personalizados };
                                                        updated[campo.id] = e.target.value;
                                                        this.setState({ filtro_campos_personalizados: updated });
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    ))} 
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <Button type="submit" variant="secondary" size="sm">
                                            <FaSearch /> Filtrar
                                        </Button>
                                        <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                            <FaEraser /> Limpar Filtro
                                        </Button>
                                    </Col>
                                    {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'gestor') && (
                                    <Col sm={6} className="text-right">
                                        <Button type="button" variant="success" size="sm" className="ms-2" onClick={() => this.exportarCSV()}>
                                            <FaRegEdit /> Exportar CSV
                                        </Button>
                                    </Col>
                                    )}
                                </Row>
                            </>
                            )}

                            {dados_usuario['prestador_categoria'] === 'medicos' && (
                                <>
                                {(() => {
                                    return (
                                        <>
                                            <Row className="g-2 mb-3">
                                                <Col sm={3}>
                                                    <Form.Group className="mb-2">
                                                        <FormLabel>Data da Solicitação</FormLabel>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={this.state.filtro_data_recebimento_inicio}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                this.setState({
                                                                    filtro_data_recebimento_inicio: val,
                                                                    filtro_data_recebimento_fim: val
                                                                });
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col sm={3}>
                                                    <Form.Group className="mb-2">
                                                        <FormLabel>Status do Pedido</FormLabel>
                                                        <Form.Select
                                                            className="form-control"
                                                            value={this.state.filtro_status_pedido}
                                                            onChange={(e) => this.setState({ filtro_status_pedido: e.target.value })}
                                                        >
                                                            <option value="">Todos</option>
                                                            {this.state.statusPedidoOptions.length > 0 ? (
                                                                this.state.statusPedidoOptions.map(status => (
                                                                    <option key={status.value} value={status.value}>{status.label}</option>
                                                                ))
                                                            ) : (
                                                                Object.entries(statusExame).map(([key, value]) => (
                                                                    <option key={key} value={key}>{value}</option>
                                                                ))
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                <Col sm={3}>
                                                    <Form.Group className="mb-2">
                                                        <FormLabel>Status do Exame</FormLabel>
                                                        <Form.Select
                                                            className="form-control"
                                                            value={this.state.filtro_status_exame}
                                                            onChange={(e) => this.setState({ filtro_status_exame: e.target.value })}
                                                        >
                                                            <option value="">Todos</option>
                                                            {this.state.statusExameOptions.length > 0 ? (
                                                                this.state.statusExameOptions.map(status => (
                                                                    <option key={status.value} value={status.value}>{status.label}</option>
                                                                ))
                                                            ) : (
                                                                Object.entries(statusExamesSelecionados).map(([key, value]) => (
                                                                    <option key={key} value={key}>{value}</option>
                                                                ))
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                <Col sm={3} xs={12}> 
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Paciente</Form.Label>
                                                        <Form.Control type="text" name="filtro_nome_paciente" value={this.state.filtro_nome_paciente} onChange={e => this.handleChangeFiltros(e, 'filtro_nome_paciente')} />    
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="auto">
                                                    <Button type="submit" variant="secondary" size="sm">
                                                        <FaSearch /> Filtrar
                                                    </Button>
                                                    {' '}
                                                    <Button
                                                        type="button"
                                                        variant="light" size="sm"
                                                        onClick={() => this.setState({
                                                            filtro_data_recebimento_inicio: '', filtro_data_recebimento_fim: '',
                                                            filtro_nome_paciente: '',
                                                            filtro_status_pedido: '', filtro_status_exame: '',
                                                            page_numb: 1,
                                                        }, () => this.consultaRegistros())}
                                                        >
                                                        <FaEraser /> Limpar Filtro
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    );
                                })()}
                            </>
                            )}
                        </Form> 

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                {dados_usuario['prestador_categoria'] !== 'medicos' ? (
                                    <tr>
                                        {!ocultarColunasEspecificas && <th>ID</th>}
                                        <th>ID Atendimento</th>
                                        <th>Diagnóstico</th>
                                        {this.state.campos_personalizados_header.map(campo => (
                                            <th key={campo.id}>{campo.nome}</th>
                                        ))}
                                        <th>Status do Programa</th>
                                        <th>Paciente</th>
                                        <th>Cidade</th>
                                        <th>UF</th>
                                        <th>Médico Solicitante</th>
                                        {!ocultarColunasEspecificas && <th>CRM/UF</th>}
                                        <th>Status do Pedido</th>
                                        <th>Data de Recebimento</th>
                                        <th>Status do Exame</th>
                                        <th>Data de Agendamento</th>
                                        <th>Data de Realização</th>
                                        <th>Local de Realização</th>
                                        {!ocultarColunasEspecificas && <th>Motorista</th>}
                                        {!ocultarColunasEspecificas && <th>Laudo</th>}
                                    </tr>
                                ) : (
                                    <tr>
                                        <th>ID</th>
                                        <th>Atendimento</th>
                                        <th>Paciente</th>
                                        <th>Exame</th>
                                        <th>Data de Solicitação</th>
                                        <th>Status do Pedido</th>
                                        <th>Status do Exame</th>
                                        <th>Laudo</th>
                                    </tr>
                                )}
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    {/* Ajustando colSpan dinamicamente para o loading também */}
                                    <td colSpan={dados_usuario['prestador_categoria'] !== 'medicos' ? (ocultarColunasEspecificas ? 17 : 21) : 9}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={dados_usuario['prestador_categoria'] !== 'medicos' ? (ocultarColunasEspecificas ? 17 : 21) : 9}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        {'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} limit={this.state.limit} />
                        }                     
                    </Card.Body>                
                </Card>

                {/* Modal para exibir o Laudo */}
                <Modal 
                    show={this.state.showModalLaudo} 
                    onHide={this.handleFecharLaudo}
                    size="xl"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Laudo do Exame</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0 }}>
                        {this.state.laudoUrl && (
                            <iframe
                                src={this.state.laudoUrl}
                                style={{ 
                                    width: '100%', 
                                    height: '75vh', 
                                    border: 'none' 
                                }}
                                title="Laudo do Exame"
                            />
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleFecharLaudo}>
                            Fechar
                        </Button>
                        {this.state.laudoUrl && (
                            <Button
                                as="a"
                                variant="outline-primary"
                                href={this.state.laudoUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaDownload className="me-1" /> Baixar / Visualizar
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Exames);
